/* Suprimal cookie consent: on-brand banner + preferences, wired to Shopify's Customer Privacy API. */
(function () {
  'use strict';
  var d = document, CATS = ['analytics', 'marketing', 'preferences', 'sale_of_data'];

  function loadApi(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy && S.customerPrivacy.setTrackingConsent) { cb(S.customerPrivacy); return; }
    if (!S || !S.loadFeatures) { cb(null); return; }
    try { S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { cb(err ? null : window.Shopify.customerPrivacy); }); }
    catch (e) { cb(null); }
  }
  function call(cp, fn) { try { return cp && typeof cp[fn] === 'function' ? cp[fn]() : undefined; } catch (e) { return undefined; } }

  function init(root) {
    if (!root || root.__sp) return; root.__sp = 1;
    var card = root.querySelector('[data-sp-consent-card]'), modal = root.querySelector('[data-sp-consent-modal]');
    var dialog = modal && modal.querySelector('[role=dialog]'), toast = root.querySelector('[data-sp-consent-toast]');
    var sod = root.querySelector('[data-sp-consent-sod]'), html = d.documentElement;
    var cp = null, opener = null, tCard, tModal, tToast;
    var forced = /[?&]sp_consent=preview\b/.test(location.search), KEY = 'sp_consent_seen';

    function seen() {
      try { if (window.localStorage.getItem(KEY)) return true; } catch (e) {}
      return /(?:^|;\s*)sp_consent_seen=1/.test(d.cookie);
    }
    function markSeen() {
      try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      try { d.cookie = KEY + '=1; max-age=31536000; path=/; SameSite=Lax'; } catch (e) {}
    }

    function showCard() {
      if (!card) return; clearTimeout(tCard); card.hidden = false;
      card.getBoundingClientRect(); card.classList.add('is-in');
    }
    function hideCard() {
      if (!card || card.hidden) return; card.classList.remove('is-in');
      tCard = setTimeout(function () { card.hidden = true; }, 500);
    }
    function showToast() {
      if (!toast) return; clearTimeout(tToast); toast.hidden = false;
      toast.getBoundingClientRect(); toast.classList.add('is-in');
      tToast = setTimeout(function () { toast.classList.remove('is-in'); tToast = setTimeout(function () { toast.hidden = true; }, 450); }, 2400);
    }
    function current() {
      var c = call(cp, 'currentVisitorConsent') || {};
      var allowed = { analytics: call(cp, 'analyticsProcessingAllowed'), marketing: call(cp, 'marketingAllowed'), preferences: call(cp, 'preferencesProcessingAllowed'), sale_of_data: call(cp, 'saleOfDataAllowed') };
      var out = {};
      CATS.forEach(function (k) { out[k] = c[k] === 'yes' ? true : c[k] === 'no' ? false : !!allowed[k]; });
      return out;
    }
    function fill() {
      var c = current();
      root.querySelectorAll('[data-sp-consent-cat]').forEach(function (i) { i.checked = !!c[i.getAttribute('data-sp-consent-cat')]; });
    }
    function openModal(from) {
      if (!modal) return; opener = from || d.activeElement; clearTimeout(tModal);
      fill(); modal.hidden = false; html.classList.add('sp-consent-lock');
      modal.getBoundingClientRect(); modal.classList.add('is-open');
      (dialog || modal).focus({ preventScroll: true });
    }
    function closeModal(back) {
      if (!modal || modal.hidden) return; modal.classList.remove('is-open'); html.classList.remove('sp-consent-lock');
      tModal = setTimeout(function () { modal.hidden = true; }, 450);
      if (back !== false && opener && opener.focus && d.contains(opener)) opener.focus({ preventScroll: true });
    }
    function save(consent) {
      markSeen();
      var done = function () {
        hideCard(); closeModal(); showToast();
        try { d.dispatchEvent(new CustomEvent('sp:consent', { detail: consent })); } catch (e) {}
      };
      if (!cp || !cp.setTrackingConsent) { done(); return; }
      var fired = false, once = function () { if (!fired) { fired = true; done(); } };
      try { cp.setTrackingConsent(consent, once); } catch (e) { once(); }
      setTimeout(once, 1500);
    }
    function all(v) { return { analytics: v, marketing: v, preferences: v, sale_of_data: v }; }
    function chosen() {
      var c = {};
      root.querySelectorAll('[data-sp-consent-cat]').forEach(function (i) { c[i.getAttribute('data-sp-consent-cat')] = i.checked; });
      if (!sod || sod.hidden) c.sale_of_data = c.marketing;
      return c;
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-sp-consent-accept]')) save(all(true));
      else if (t.closest('[data-sp-consent-decline]')) save(all(false));
      else if (t.closest('[data-sp-consent-save]')) save(chosen());
      else if (t.closest('[data-sp-consent-close]')) closeModal();
    });
    d.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sp-consent-open]');
      if (o) { e.preventDefault(); openModal(o); }
    });
    d.addEventListener('keydown', function (e) {
      if (!modal || modal.hidden) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(modal.querySelectorAll('button,input,a[href]')).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && (d.activeElement === f[0] || d.activeElement === dialog)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    if (root.hasAttribute('data-design')) {
      d.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) showCard(); });
      d.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) hideCard(); });
    }

    loadApi(function (api) {
      cp = api;
      if (sod && call(cp, 'saleOfDataRegion')) sod.hidden = false;
      var show = forced;
      var pageOk = root.getAttribute('data-show-on') !== 'home' || root.hasAttribute('data-home');
      if (!show && cp && pageOk && !seen()) {
        if (root.getAttribute('data-mode') === 'all') {
          var c = call(cp, 'currentVisitorConsent') || {};
          show = !c.analytics && !c.marketing && !c.preferences;
        } else {
          show = !!call(cp, 'shouldShowBanner');
        }
      }
      if (show) setTimeout(function () { showCard(); if (!forced) markSeen(); }, 700);
    });
  }

  function boot() { d.querySelectorAll('[data-sp-consent]').forEach(init); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-sp-consent]'); if (r) init(r); });
})();